import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProductSpecificPackagingTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import packagingIcon from "../../../../../assets/new-product-detail-cats/sub-icons/product-component-icon.svg"; // TODO: Replace with appropriate icon
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProductSpecificPackaging = ({ productId, systemBoundaryProps }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents product-specific-packaging-contents">
      <SubHeaderBox
        subTitle={
          t("PRODUCT_SPECIFIC_PACKAGING") || "Product specific packaging"
        }
        subDescription={
          t("PRODUCT_SPECIFIC_PACKAGING_DESC") ||
          "e.g. hangtag, shoebox with the size number on it, or other container items etc-"
        }
        isNormal={true}
        number={"31.1b"}
        systemBoundaryProps={systemBoundaryProps}
        showSystemBoundary={false}
        icon={packagingIcon}
      />

      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`product-specific-packaging-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProductSpecificPackagingTable productId={productId} />
        </TableLoadingWrapper>
      )}

      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProductSpecificPackaging;
